import { connect } from 'react-redux';

import { invoicesActions } from 'dataflow/distributorPortal/actions';

import GeneralInvoicesPresentation from './GeneralInvoicesPresentation';

function mapStateToProps(state) {
    const { 
        getGeneralInvoices_requesting, getGeneralInvoices_status,
        generalInvoiceList, generalInvoiceListHeaders
    } = state.distributorPortal_invoicesReducers;

	return {
        getGeneralInvoices_requesting, getGeneralInvoices_status,
        generalInvoiceList, generalInvoiceListHeaders
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGeneralInvoices: (pageNo, pageSize, sort, filterOptions) => { dispatch(invoicesActions.getGeneralInvoices(pageNo, pageSize, sort, filterOptions)); },
    };
}

const GeneralInvoices = connect(mapStateToProps, mapDispatchToProps)(GeneralInvoicesPresentation);

export default GeneralInvoices;